import Vue from "vue";
import VueCookie from "vue-cookies";
import {shoppingCartService} from "../network/services/shopping-cart.service";
import {ResponseError} from "../network/response/response-error";
import booking from './shopping-cart/booking.store';
import {bookingService} from "../network/services/booking.service";

const COOKIE_NAME = 'mihShoppingCartUuid';
Vue.use(VueCookie);

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export default {
    namespaced: true,
    state: {
        uuid: (Vue.$cookies.get(COOKIE_NAME) || {uuid: uuidv4()}).uuid,
        loading: false,
        init: false,
        bookings: [],
        paying: null,
        payLoading: false,
        payErrors: [],
    },
    getters: {
        loading(state) {
            return state.loading
        },
        cartCount(state) {
            return state.bookings.reduce((result, booking) => {
                return result + booking.booking_rooms.length;
            }, 0);
        },
        totalPrice(state) {
            function calcExtraPrice(extra, dates, discount = false) {
                let price = extra.price.amount;
                const count = Math.max(1, dates.reduce((prev, curr) => {
                    return prev + curr.count
                }, 0));
                if (['EACH', 'PERSON', 'NONE', 'HOUR', 'DAY'].indexOf(extra.type) !== -1) {
                    price *= count;
                }
                if (discount && extra.discount) {
                    if (extra.discount.type === 'FIX') {
                        price -= extra.discount.amount.amount;
                    } else {
                        price -= price * extra.discount.amount.amount / 100;
                    }
                }
                return price;
            }

            return state.bookings.reduce((total, booking) => {
                return total +
                    booking.booking_rooms.reduce((total, bookingRoom) => {
                        return total +
                            bookingRoom.extras.reduce((total, extraBooking) => {
                                return total + calcExtraPrice(extraBooking.extra, extraBooking.dates, true);
                            }, 0) +
                            bookingRoom.price_plans.reduce((total, pricePlan) => {
                                return total +
                                    pricePlan.input_prices.reduce((total, input) => {
                                        return total +
                                            input.edges.reduce((total, edge) => {
                                                return total + edge.totalPrice - edge.optionsAdditionalPrice;
                                            }, 0)
                                    }, 0)
                            }, 0)
                    }, 0);
            }, 0);
        },
        bookings(state) {
            return state.bookings;
        },
        rooms(state) {
            return state.bookings.reduce((result, booking) => {
                result.push(...booking.booking_rooms.map((bookingRoom) => {
                    return {
                        start: booking.start,
                        end: booking.end,
                        room: bookingRoom.room,
                        id: bookingRoom.id,
                        room_price_id: booking.room_price.id,
                        price_plans: bookingRoom.price_plans,
                        extras: bookingRoom.extras,
                        sc_booking_id: booking.id,
                    }
                }))
                return result;
            }, []);
        },
        roomIds(state, getters) {
            return getters.rooms.map(r => r.room.id);
        },
    },
    mutations: {
        SET_PAY_LOADING(state, payload) {
            state.payLoading = !!payload;
        },
        ADD_PAY_ERRORS(state, payload) {
            state.payErrors.push(...payload);
        },
        CLEAR_PAY_ERRORS(state) {
            state.payErrors = [];
        },
        SET_INIT(state) {
            state.init = true;
        },
        SET_LOADING(state, payload) {
            state.loading = !!payload;
        },
        SET_PAYING(state, payload) {
            state.payLoading = false;
            state.payErrors = [];
            if (payload === null) {
                state.paying = null;
                return;
            }
            const found = state.bookings.filter((b) => b.id === payload);
            if (found.length === 0) {
                state.paying = null;
                return;
            }
            state.paying = found[0];
        },
        SET_SC(state, payload) {
            if (payload) {
                state.bookings = payload;
                return;
            }
            state.bookings = [];
        },
        PERSIST(state, payload) {
            Vue.$cookies.set(COOKIE_NAME, {uuid: state.uuid}, Infinity);
        }
    },
    actions: {
        async deleteCurrent(context) {
            const accessToken = context.rootState.client.tokens.accessToken;
            if (!accessToken) {
                console.error('no auth');
                return;
            }
            if (!context.state.paying) {
                console.error('no current paying');
                return;
            }
            // await context.dispatch('booking/delete', {id: context.state.paying.id});
        },
        async setPaying(context, id) {
            const from = context.state.paying;
            context.commit('SET_PAYING', id);
            if (from === null || context.state.paying === null || (from.id !== undefined
                && context.state.paying.id !== undefined
                && from.id !== context.state.paying.id)) {
                await context.dispatch('booking/personal/reset');
            }
        },
        async createBooking(context) {
            const accessToken = context.rootState.client.tokens.accessToken;
            const uuid = context.state.uuid;
            if (!accessToken) {
                console.error('no auth');
                return;
            }
            if (!context.state.paying) {
                console.error('no booking selected');
                return;
            }
            if (!context.state.booking.personal.card) {
                console.error('no card selected');
                return;
            }
            context.commit('SET_PAY_LOADING', true);
            context.commit('CLEAR_PAY_ERRORS');
            const rooms = context.state.paying.booking_rooms.map((br) => ({
                id: br.room.id,
                start: context.state.paying.start,
                end: context.state.paying.end,
                priceplan: context.state.paying.room_price.id,
                options: context.state.paying.price_options.map(p => p.id),
                nb_guest: br.nb_guests,
                extras: br.extras.map(extra => ({
                    id: extra.extra.id,
                    dates: extra.dates
                }))
            }));
            const infoPhone = context.state.booking.personal.phone;
            const infoEmail = context.state.booking.personal.email;
            const infoFirstName = context.state.booking.personal.firstName;
            const infoLastName = context.state.booking.personal.lastName;

            const card = context.state.booking.personal.card.getId();
            const address_id = context.state.booking.personal.address_id;
            const sc_booking_id = context.state.paying.id;

            const realData = {
                rooms, infoPhone, infoEmail, infoFirstName, infoLastName, card, address_id, sc_booking_id
            };
            const response = await bookingService.createBooking(accessToken, uuid, realData);
            if (response instanceof ResponseError) {
                // error
                console.error(response);
                context.commit('ADD_PAY_ERRORS', ['SERVER_ERROR']);
                context.commit('SET_PAY_LOADING', false);
                return;
            }

            context.commit('SET_PAY_LOADING', false);
            const paymentIntent = response.get('Booking.create.paymentIntent', null);
            if (paymentIntent instanceof ResponseError) {
                context.commit('ADD_PAY_ERRORS', paymentIntent.getErrors());
                return;
            }
            if (paymentIntent.hasOwnProperty('error')) {
                context.commit('ADD_PAY_ERRORS', ['PAYMENT_ERROR']);
                return {
                    redirect: null,
                    params: {
                        payment_intent_client_secret: paymentIntent.error.payment_intent.client_secret,
                        payment_intent: paymentIntent.error.payment_intent.id
                    }
                }
            }
            if (paymentIntent.hasOwnProperty('link')) {
                return {
                    redirect: String(result.link),
                }
            } else if (typeof paymentIntent === 'string') {
                return {
                    redirect: String(result),
                }
            } else if (paymentIntent.next_action && paymentIntent.next_action.type === 'redirect_to_url') {
                return {
                    redirect: String(paymentIntent.next_action.redirect_to_url.url)
                }
            } else if (paymentIntent.next_action && paymentIntent.next_action.type === 'three_d_secure_redirect') {
                return {redirect: String(paymentIntent.next_action.stripe_js.url)}
            }
            return {
                redirect: null,
                params: {
                    payment_intent_client_secret: paymentIntent.client_secret,
                    payment_intent: paymentIntent.id
                }
            }
        },
        async init(context, options = null) {
            let lang;
            if (!options || !options.lang) {
                lang = context.rootState.lang.currentLang;
            } else {
                lang = options.lang;
            }
            context.commit('PERSIST');
            context.commit('SET_PAYING', null);
            const uuid = Vue.$cookies.get(COOKIE_NAME).uuid;
            context.commit('SET_LOADING', true);
            context.commit('SET_INIT');
            const token = context.rootState.client.tokens.accessToken;
            shoppingCartService.setAuth(context.rootState.client.tokens.accessToken);
            const response = await shoppingCartService.retrieveV2(uuid, token, lang);
            const cart = response.get('ShoppingCart.bookings', []);
            if (cart instanceof ResponseError) {
                context.commit('SET_LOADING', false);
                context.commit('SET_SC', null);
            } else {
                context.commit('SET_SC', cart);
            }
            context.commit('SET_LOADING', false);
        },
        async persist(context) {
            context.commit('PERSIST');
        }
    },
    modules: {booking},
}



// WEBPACK FOOTER //
// ./src/stores/shopping-cart.store.js